import React, { useContext } from 'react'
import scrollTop from '../helpers/scrollTop'
import displayINRCurrency from '../helpers/displayCurrency'
import Context from '../context'
import addToCart from '../helpers/addToCart'
import { Link } from 'react-router-dom'
import safeImageUrl from '../helpers/safeImageUrl'

const VerticalCard = ({loading,data = []}) => {
  const loadingList = new Array(13).fill(null)

  const { fetchUserAddToCart } = useContext(Context);

  const handleAddToCart = async (e, id, isOutOfStock) => {
    e.preventDefault();
    e.stopPropagation();

    if(isOutOfStock) return;

    await addToCart(e, id)
    fetchUserAddToCart()
  }

  return (
    <div className='grid grid-cols-[repeat(auto-fit,minmax(300px,320px))] justify-center md:justify-between md:gap-6'>

      { loading ? (
        loadingList.map((_, index)=>(
          <div key={index} className='w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] bg-white rounded-sm shadow-md'>
            <div className='bg-white h-52 animate-pulse' />
            <div className='p-4 grid gap-3'>
              <div className='h-5 bg-white rounded animate-pulse' />
              <div className='h-4 bg-white rounded animate-pulse' />
              <div className='h-4 bg-white rounded animate-pulse' />
              <div className='h-8 bg-white rounded-full animate-pulse' />
            </div>
          </div>
        ))
      ) : (
        data.map((product)=>{

          const isOutOfStock = product?.stock === 0;

          return (
            <div 
              key={product?._id}
              className='w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] bg-white rounded shadow-md border border-slate-400 overflow-hidden relative mb-4'
            >

              {/* OUT OF STOCK BADGE */}
              {isOutOfStock && (
                <span className='absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded z-10'>
                  Out of Stock
                </span>
              )}

              {/* CLICKABLE PRODUCT SECTION */}
              <Link to={`/product/${product?._id}`} onClick={scrollTop}>
                <div className='bg-white h-64 w-full flex items-center justify-center'>
                  <img 
                    src={safeImageUrl(product?.productImage?.[0])} 
                    alt={product?.productName}
                    className={`max-w-full max-h-full object-contain transition-all
                      ${isOutOfStock ? "opacity-60" : "hover:scale-100"}`}
                  />
                </div>

                <div className='p-4 grid'>
                  <h2 className='font-medium text-base md:text-lg line-clamp-1 text-orange-950'>
                    {product?.productName}
                  </h2>

                  <p className='capitalize text-orange-900 text-sm'>
                    Category :- {product?.category}
                  </p>

                  <div className='flex gap-3'>
                    <p className='text-orange-950 font-medium'>
                      {displayINRCurrency(product?.sellingPrice)}
                    </p>

                    <p className='text-orange-900 line-through'>
                      {displayINRCurrency(product?.price)}
                    </p>
                  </div>
                </div>
              </Link>

              {/* FOOTER BUTTONS */}
              <div className='p-4 pt-0 flex justify-center'>
                <Link to={`/product/${product?._id}`}>
                  <button className='text-sm px-5 border-[#5a3620] font-medium py-2 w-28 rounded border-2 text-[#5a3620] mr-3'>
                    View More
                  </button>
                </Link>

                <button
                  disabled={isOutOfStock}
                  onClick={(e)=>handleAddToCart(e, product?._id, isOutOfStock)}
                  className={`text-sm px-4 py-2 w-36 rounded 
                    ${isOutOfStock 
                      ? "bg-gray-400 cursor-not-allowed text-white"
                      : "bg-[#5a3620] font-medium border-[#5a3620] text-white"
                    }`}
                >
                  {isOutOfStock ? "Out of Stock" : "Add to Cart"}
                </button>
              </div>

            </div>
          )
        })
      )}
    </div>
  )
}

export default VerticalCard
